export const LoginUrl = "https://alembic.co.in:7443/Umang/login";
// "https://webqa.alembic.co.in:9001/Eklavya_v1/login";

export const baseUrl =
  // UAT
  // "https://fxb9j0papd.execute-api.ap-south-1.amazonaws.com/uat/";

// Dev
  "https://dqninspzbk.execute-api.ap-south-1.amazonaws.com/Dev/";

export const UserSessionUrl = `${baseUrl}users_details`;

export const UserFeedBackUrl = `${baseUrl}session/rating/`;

export const QueryFeedBackUrl = `${baseUrl}session/`;

export const chatHistoryUrl = `${baseUrl}session/chat-history/`;
